import axios from '@axios'

export const useApi = {
  logoutCurrentSession(headers, { timeout, signal }) {
    return axios.post(
      '/Kernal/Auth/Logout',
      {},
      {
        headers,
        timeout,
        signal,
        currentSessionLogout: true,
      }
    )
  },
  async apiCall(endpointConfig, payload = {}, requestOptions = {}) {
    const { url, method, headers, identifierKey } = endpointConfig
    const { signal, timeout, retry } = requestOptions

    const options = {
      ...(signal !== undefined ? { signal } : {}),
      ...(timeout !== undefined ? { timeout } : {}),
      ...(retry !== undefined ? { retry } : {}),
    }

    let apiURL = url
    if (identifierKey) {
      const identifier = requestOptions.pathParams?.[identifierKey]
      const placeholder = `{${identifierKey}}`
      if (typeof identifier !== 'string' || !identifier || !url.includes(placeholder)) {
        throw { message: 'Missing endpoint identifier', responseCode: 400 }
      }
      apiURL = url.replace(placeholder, encodeURIComponent(identifier))
    } else if (payload?.guid) {
      apiURL = `${url}/${payload.guid}`
      delete payload.guid
    }

    try {
      let response
      if (method === 'get') {
        const requestHeaders = headers ? { ...payload.headers, ...headers } : payload.headers

        response = await axios.get(
          apiURL,
          requestHeaders
            ? { ...payload, ...options, headers: requestHeaders }
            : { ...payload, ...options }
        )
      } else if (method === 'delete') {
        response = await axios.delete(apiURL, { ...options, data: payload, headers })
      } else {
        response = await axios[method](apiURL, payload, { ...options, headers })
      }

      return {
        data: response.data,
        responseCode: response.status,
        headers: response.headers,
        ...(response.guestRecoveryEpoch !== undefined
          ? { guestRecoveryEpoch: response.guestRecoveryEpoch }
          : {}),
      }
    } catch (error) {
      const data = error?.data ?? null
      const serviceData = error?.serviceData ?? data?.serviceData ?? null
      const responseCode = error?.responseCode ?? error?.status ?? 500
      const message = error?.message ?? data?.message ?? 'Error'
      throw {
        message,
        requestID: data?.requestID,
        error: data?.error,
        responseCode,
        // Only an HTTP answer carries a message written for the user; the client reports a
        // transport failure with a 500 as well.
        fromResponse: error?.fromResponse === true,
        errors: data?.errors,
        serviceData,
        data,
        headers: error?.headers,
      }
    }
  },

  /*

  for (let i = 0; i < 20; i++) {
    console.error(`Validation Error: ${error}`, errorResponse.data)
    console.warn(`IF YOU SEE THIS MESSAGE ENSURE THE ERROR IS HANDLE IT WITHIN THE STORE AND DISPLAY A FORMATTED VERSION TO THE USER`)
  }
  */
}
